import React from "react";

type ProfileImageProps = {
  color?: string;
  width?: number;
  height?: number;
  style?: React.CSSProperties;
  borderOutlineColor?: string;
};

const SlothProfileGlasses = ({ color, width, height, style, borderOutlineColor }: ProfileImageProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="-2 -2 184 184"
    fill="none"
    style={style}
  >
    <g clipPath="url(#clip0_474_623)">
      <path
        d="M90 179C139.1533 179 179 139.1533 179 90C179 40.8467 139.1533 1 90 1C40.8467 1 1 40.8467 1 90C1 139.1533 40.8467 179 90 179Z"
        fill="var(--jungle-art-avatar-disc, #FBFFDF)"
        stroke={borderOutlineColor}
        strokeWidth={borderOutlineColor ? 1 : 0}
      />
      <mask
        id="mask0_474_623"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="180"
        height="180"
      >
        <path
          d="M90 179C139.1533 179 179 139.1533 179 90C179 40.8467 139.1533 1 90 1C40.8467 1 1 40.8467 1 90C1 139.1533 40.8467 179 90 179Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_474_623)">
        <path
          d="M168.18 192.84C168.68 193.17 169.16 192.34 169.19 191.75C169.51 185.65 166.63 179.86 163.56 174.59C158.41 165.74 152.57 157.31 146.16 149.32C144.59 147.37 142.97 145.45 140.96 143.97C139.51 142.91 134.37 135.07 132.59 134.98C130.81 134.89 132.24 141.95 131.58 143.95C131.06 145.51 130.66 147.09 130.86 148.72C132.31 160.4 130.97 172.63 134.1 183.98C134.4 185.01 134.69 186.08 135.31 186.97C136.64 188.86 139.04 189.6 141.28 190.22C146.57 191.7 151.86 193.15 157.13 194.63C159.32 195.25 161.54 195.84 163.81 195.78C166.08 195.72 166.8 194.69 168.19 192.88V192.85L168.18 192.84Z"
          fill="#894C0A"
        />
        <path
          d="M161.7 176.09C164.09 176.09 166.24 177.27 167.78 179.1C168.42 179.86 169.56 180.49 169.95 181.53C170.19 182.15 170.07 182.95 169.54 183.33C168.95 183.74 168.12 183.54 167.41 183.6C166.26 182.27 164.63 181.41 163.3 180.26C162.77 179.79 162.27 179.25 161.97 178.6C161.76 178.1 161.67 177.57 161.62 177.03C161.56 176.68 161.71 176.44 161.68 176.08H161.71L161.7 176.09Z"
          fill="#894C0A"
        />
        <path
          d="M169.47 191.75C169.62 188.94 169.06 186.19 168.14 183.56C168.67 183.56 169.17 183.65 169.62 183.29C170.15 182.88 170.27 182.11 170.03 181.49C169.79 180.87 169.29 180.4 168.79 179.95C167.78 179.12 166.72 178.38 165.6 177.73C165.19 176.93 164.51 175.75 164.06 174.95C161.9 175.28 159.92 175.75 157.97 176.9C156.85 177.58 155.81 178.41 154.92 179.35C152.02 182.42 150.75 187.1 150.81 191.32C150.81 191.79 150.87 192.3 150.93 192.77C153.09 193.36 155.25 193.98 157.4 194.6C159.59 195.22 161.83 195.81 164.08 195.75C166.33 195.69 167.04 194.66 168.43 192.85C168.93 193.18 169.44 192.35 169.46 191.73L169.47 191.75Z"
          fill="#894C0A"
        />
        <path
          d="M124.83 117.36C131.3 125.37 135.86 142.82 138.73 152.69C143.58 169.45 143.37 168.83 147.3 195.8C148.25 202.33 147 224.39 147.6 230.95C148.58 241.83 149.29 253.77 142.87 262.64C139.35 267.52 134 270.83 128.29 272.78C122.58 274.73 116.55 275.35 110.55 275.62C92.6298 276.45 74.5698 274.32 57.3298 269.26C47.5998 266.42 31.9298 262.84 25.5198 255.01C21.2598 249.84 15.7598 244.34 15.7598 237.6C15.7598 230.86 16.1998 225.54 16.5598 218.83C17.5898 199.35 19.3698 196.66 24.5398 178.09C26.8498 169.81 30.5998 147.4 32.4298 139C34.4998 129.45 33.6698 113.01 34.5898 112.63C40.2098 104.32 53.8998 119.28 63.4798 116.38C73.0598 113.48 89.3798 113.07 99.3998 113.19C104.78 113.25 110.25 113.46 115.37 115.11C118.71 116.17 121.4 116.68 124.83 117.36Z"
          fill="#9B5808"
        />
        <path
          d="M86.0399 238.88C85.8599 241.63 87.8699 244.14 90.3299 245.35C92.7899 246.56 95.6199 246.71 98.3699 246.71C104.37 246.65 110.37 245.85 116.2 244.34C120.25 243.28 124.57 241.86 128.74 242.3C132.29 241.24 134.09 237.36 135.33 233.87C137.58 227.57 139.44 221.1 139.97 214.45C140.5 207.8 140.47 195.38 139.62 188.76C137.58 173.03 136.87 165.82 132.11 152.04C131.22 149.5 129.98 147.07 128.12 145.15C124.48 141.34 118.87 139.86 113.6 140.3C108.33 140.74 103.37 142.9 98.7599 145.44C96.8399 146.5 94.9799 147.63 93.2899 148.99C88.5599 152.86 85.5399 158.51 83.8299 164.39C82.1199 170.27 81.6099 176.42 81.1099 182.51C79.8099 198.39 79.5399 214.56 82.2899 230.26C82.8499 233.39 83.7699 236.68 86.0399 238.86V238.88Z"
          fill="#BE8960"
        />
        <path
          d="M103.84 41.3798C70.6999 40.5498 49.9699 53.2098 39.4499 81.0598C25.0499 118.02 37.9099 138.42 79.9799 134.63C94.9699 132.92 116.55 139.15 132.4 132.21C129.95 127.66 146.03 115.3 150.61 108.91C158.86 96.8198 157.82 79.9098 151.17 67.3398C141.89 50.3698 136.74 36.7698 104.72 41.2898L103.83 41.3798H103.84Z"
          fill="#9B5808"
        />
        <path
          d="M133.55 114.01C139.11 111.73 144.84 106.29 146.94 101C150.64 91.78 150.19 81.31 147.09 71.85C145.11 65.79 142.54 59.2 136.59 56.03C134.49 54.91 132.1 54.26 129.76 54.61C127.42 54.96 125.18 56.41 124.29 58.63C123.88 59.66 123.76 60.85 122.99 61.68C122.22 62.51 121.48 62.54 120.33 61.38C114.95 55.82 107.85 51.77 100.11 51.59C94.1096 51.47 88.2196 53.75 83.1696 56.97C79.0296 59.57 75.5996 62 72.1396 67.35C67.5796 74.43 66.3696 83.23 68.3496 91.43C69.9596 98.11 76.5496 106.25 82.5296 109.61C88.8996 113.18 95.6896 116.26 102.94 117.28C106.4 117.75 109.89 117.87 113.35 117.9C115.95 117.93 118.58 117.96 121.18 117.63C125.44 117.1 129.55 115.62 133.51 113.99H133.54L133.55 114.01Z"
          fill="#FFD29F"
        />
        <path
          opacity="0.96"
          d="M97.22 58.3497C94.17 58.5897 91.22 60.5097 88.38 62.3997C81.73 66.2997 74.29 70.7697 68.37 75.7097C66.95 80.5897 67.06 85.8697 68.1 90.9197C68.96 95.1197 71.64 99.0597 74.24 102.46C80.01 99.6497 85.77 96.8397 91.45 93.8297C99.17 89.8097 109.07 84.9597 110.7 76.2697C112.5 66.7797 108.51 56.8197 97.22 58.3197V58.3497Z"
          fill="#5C2600"
        />
        <path
          opacity="0.96"
          d="M142.16 84.4399C143.76 84.7699 147.93 84.7099 149.52 84.2299C149.22 78.6399 148.19 74.5899 147.13 71.4899C145.21 65.8999 143.97 62.2099 140.24 58.3299C138.2 57.5599 136.1 57.4999 134.53 58.2399C133.47 58.7399 132.49 60.4299 132.37 61.0199C130.92 66.6099 131.93 75.1199 135.62 80.0899C137.31 81.8299 139.79 83.9599 142.18 84.4399H142.15H142.16Z"
          fill="#5C2600"
        />
        <path
          d="M103.99 68.5197C99.4096 68.3397 94.7996 68.7297 90.3596 70.1197C88.1696 70.7997 85.9296 71.8297 84.4796 73.8197C83.3896 75.2997 82.8196 77.2197 82.9096 79.1397C82.9996 81.0597 83.7696 82.8897 84.9796 84.2297C87.0196 86.4497 90.1196 87.0097 92.9296 86.6797C96.3596 86.2697 99.6996 84.6997 102.33 82.1897C103.39 81.1797 104.37 79.9997 104.99 78.6097C105.55 77.3097 105.82 75.8897 106.02 74.4697C106.14 73.6997 106.23 72.8997 106.14 72.0997C105.99 70.8897 105.34 69.7597 104.45 69.1097C103.56 68.4597 102.35 68.2797 101.32 68.6397"
          fill="#5C2600"
        />
        <path
          d="M88.3499 66.8696C80.7499 71.2796 83.7099 81.9796 91.9299 83.6296C100.15 85.2896 108.07 76.2396 103.9 69.9696C100.2 64.2596 93.6999 64.4996 88.3499 66.8396V66.8696Z"
          fill="#FAF6D6"
        />
        <path
          d="M93.9099 67.5798C88.7999 71.0098 90.5099 80.4998 96.5099 81.9198C102.51 83.3398 108.28 75.5898 105.23 70.2098C102.54 65.3298 95.7399 63.9398 93.9099 67.5798Z"
          fill="#522E2D"
        />
        <path
          d="M135.77 64.18C138.31 64 138.43 61.52 140.86 62.91C142.07 63.59 143.31 64.62 144.11 66.58C144.7 68.03 145.03 69.95 144.97 71.84C144.91 73.73 144.5 75.57 143.82 76.9C142.7 79.09 140.98 79.65 139.41 79.32C137.52 78.91 135.68 77.34 134.21 74.86C133.62 73.85 135.51 75.54 135.19 74.15C134.86 72.88 134.72 71.46 134.6 70.04C134.54 69.27 134.48 68.47 134.54 67.7C134.63 66.49 134.98 65.39 135.49 64.74C136 64.09 136.64 63.91 137.23 64.27"
          fill="#5C2600"
        />
        <path
          d="M141.57 63.3798C145.44 67.1898 143.94 76.4498 139.74 77.8998C135.54 79.3498 131.49 71.4798 133.62 66.0998C135.51 61.1598 138.82 61.3698 141.57 63.4098V63.3798Z"
          fill="#FAF6D6"
        />
        <path
          d="M139.73 63.8497C142.63 66.9497 141.65 75.5597 138.25 76.8297C134.85 78.0997 131.54 71.0897 133.28 66.2497C134.82 61.8197 138.69 60.5697 139.73 63.8597V63.8497Z"
          fill="#522E2D"
        />
        <path
          opacity="0.1"
          d="M71.9996 105.14C76.1096 101.41 81.8696 100.05 87.3996 99.91C90.8296 99.82 94.3796 100.15 97.3596 101.83C100.29 103.49 102.39 106.29 103.89 109.28C106.11 113.69 107.14 119.07 104.92 123.47C103 127.25 99.2396 130.74 95.1596 131.9C89.6296 133.44 86.2896 133.26 82.2096 132.05C77.6296 130.69 71.2396 128 68.7896 123.56C65.9796 118.5 67.8996 108.84 72.0096 105.14H71.9796H71.9996Z"
          fill="#FF5580"
        />
        <path
          opacity="0.1"
          d="M156.38 86.9698C154.78 86.1398 152.68 85.4298 151 85.3398C149.08 85.2498 147.07 85.5498 145.38 86.9998C143.72 88.4198 142.54 90.7798 141.71 93.3298C140.47 97.0598 139.88 101.67 141.15 105.39C142.21 108.61 144.34 111.57 146.65 112.54C147.89 113.07 146.53 112.54 147.48 112.66C147.72 112.36 147.92 112.07 148.13 111.8C153.13 106.01 157.44 95.9198 156.38 86.9698Z"
          fill="#FF5580"
        />
        <path
          d="M127.02 79.7598C132.84 75.7398 130.27 70.2998 123.24 71.6598C120.22 72.2198 117 73.9398 118.18 77.0398C119.57 79.6098 123.95 80.9098 126.64 79.9698L127.05 79.7898L127.02 79.7598Z"
          fill="#522E2D"
        />
        <path
          d="M120.16 96.6699C122.35 98.0299 123.89 98.7999 126.46 98.6499C128.65 98.5299 130.07 98.1499 131.6 96.6099"
          stroke="#522E2D"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M79.86 161.31C76.76 165.65 80.07 171.92 83.3 176.66C84.62 178.6 87.2 181.38 89.07 182.79C92 184.99 95.14 186.89 98.28 188.83C106.03 193.56 113.74 198.32 121.49 203.05C125.01 205.21 128.79 207.69 130.15 211.59C130.59 212.89 130.74 214.28 130.65 215.67C130.47 217.95 129.64 217.68 127.63 218.8C126.42 219.48 124.97 219.6 123.58 219.54C121.33 219.45 117.67 219.27 115.04 218.92C105.73 217.65 98.19 215.96 88.79 213.6C76.99 210.64 64.78 205.77 57.57 195.98C54.26 191.49 50.56 184.8 49.03 179.45C47.79 175.19 50.36 174.22 51.87 178.12C53.56 182.44 61.66 181.85 62.45 180.07C64.7 175.1 60.59 153.73 65.58 151.54C67.83 150.56 70.22 149.74 72.68 149.62C75.14 149.5 77.71 150.12 79.57 151.75C82.47 154.23 79.42 157.54 79.9 161.3H79.87L79.86 161.31Z"
          fill="#894C0A"
        />
        <path
          d="M85.8901 158.11C82.4301 162.96 82.4301 170.02 85.8901 174.87C87.4001 176.97 89.4401 178.65 91.5701 180.16C94.2001 182.05 96.9801 183.74 99.7601 185.45C107.51 190.18 115.22 194.94 122.97 199.67C126.49 201.83 130.27 204.31 131.63 208.21C132.07 209.51 132.22 210.9 132.13 212.29C131.95 214.57 130.98 216.96 128.97 218.06C127.76 218.74 126.31 218.86 124.92 218.8C122.67 218.71 120.46 218.15 118.27 217.59C108.93 215.22 99.5601 212.89 90.3001 210.2C78.5901 206.8 66.2901 202.37 59.0801 192.58C55.7701 188.09 53.7601 182.76 51.8101 177.5C50.2701 173.36 52.3401 168.57 53.3501 164.25C53.7901 162.36 54.2401 160.47 55.0401 158.72C57.2901 153.75 62.0801 150.35 67.1001 148.17C69.3501 147.19 71.7401 146.37 74.2001 146.25C76.6601 146.13 79.2301 146.75 81.0901 148.38C83.9901 150.86 85.4701 154.35 85.9401 158.14L85.9101 158.11H85.8901Z"
          fill="#9B5808"
        />
        <path
          d="M116.11 70.9496C118.15 67.7296 127.94 65.8896 131.72 69.9996"
          stroke="#581E06"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M94.9397 94.6298C106.532 94.6298 115.93 85.774 115.93 74.8498C115.93 63.9256 106.532 55.0698 94.9397 55.0698C83.3473 55.0698 73.9497 63.9256 73.9497 74.8498C73.9497 85.774 83.3473 94.6298 94.9397 94.6298Z"
          stroke="#581E06"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M142.564 86.4939C147.583 86.1421 151.166 78.9253 150.567 70.3749C149.967 61.8244 145.413 55.1781 140.394 55.5299C135.375 55.8818 131.792 63.0985 132.391 71.649C132.991 80.1995 137.545 86.8458 142.564 86.4939Z"
          stroke="#581E06"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M135.66 48.9598C129.76 42.9998 121.53 40.4398 104.14 40.0898H102.91C89.3399 41.4798 78.9698 44.1798 69.8398 48.9598H135.67H135.66Z"
          fill="#9B5808"
        />
        <path
          d="M67.6597 48.1799C67.6597 48.1799 70.7097 37.2999 75.7597 35.6699C76.0597 38.3599 76.7097 40.3099 76.7097 40.3099L79.9297 38.4799C79.9297 38.4799 75.1697 44.2199 91.1397 41.8499C79.3097 48.4399 67.6697 48.1499 67.6697 48.1499V48.1799H67.6597Z"
          fill="#9B5808"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_474_623">
        <rect width="180" height="180" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default SlothProfileGlasses;
